import { pipe } from 'fp-ts/function';
import { createAuthorizedPostRequest, fetchApi, setBody } from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';

export const resourceBulkDelete = (records: number[], baseUrl: string) => pipe(
  `${baseUrl}/delete`,
  createAuthorizedPostRequest,
  map(setBody({ records })),
  chain(fetchApi),
);
